"use client";
import { motion } from "motion/react";

interface LoadingSpinnerProps {
  isVisible?: boolean;
}

export default function LoadingSpinner({
  isVisible = true,
}: LoadingSpinnerProps) {
  return (
    <motion.div
      className="flex flex-col items-center justify-center min-h-[200px]"
      initial={{ opacity: 0 }}
      animate={{ opacity: isVisible ? 1 : 0 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.2, ease: "easeInOut" }}
    >
      <motion.div
        className="w-8 h-8 border-4 rounded-full"
        style={{
          borderColor: "var(--color-alias-neutral-light)",
          borderTopColor: "var(--color-alias-info)",
        }}
        initial={{ rotate: 0 }}
        animate={{ rotate: 360 }}
        transition={{
          duration: 0.375,
          repeat: Infinity,
          ease: "linear",
          delay: 0,
        }}
      />
      <div className="mt-4 text-sm" style={{ color: "var(--color-alias-neutral-dark)" }}>Loading survey...</div>
    </motion.div>
  );
}
